import { render } from "./CardVaultEdit.vue?vue&type=template&id=173b55da"
import script from "./CardVaultEdit.vue?vue&type=script&lang=js"
export * from "./CardVaultEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__